import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { Dimmer } from "semantic-ui-react";
import Table from "../../../components/Table/Table";
import { EditActions, editActions } from "../../../actions/editActions";
import EditKCEVersionCommon from "../../Editing/EditVersionCommon";
import { Filter } from "../../../components/Table/Migration/LegacyTypes";
import { pdApiActions } from "../../../actions/pdApiActions";
import _ from "lodash";

type StateProps = {
  pdApi: State.PdApi;
  columns: State.ColumnMap;
  mainState: State.Main;
  editedObjectId: number | undefined;
  isEditActive: boolean;
  objectIdentifier: string;
  rows: Api.EscalatorVersion[];
  isLoadingEscalatorVersions: boolean;
};

type DispatchProps = {
  editActions: typeof editActions;
  pdApiActions: typeof pdApiActions;
};

type OwnProps = {  
  columnFilters?: Filter[];
  subMenuRoute: State.EscalatorBindingsSubmenu;
  toggleModal: () => void;
  setColumnFilters: (subMenuRoute: State.EscalatorBindingsSubmenu, columnFilter: Filter[]) => void;
};

// Props of the component
export type EscalatorVersionProps = StateProps & DispatchProps & OwnProps;

// Container for listing escalator versions in a table
export class EscalatorVersions extends React.Component<EscalatorVersionProps> {

  componentDidMount(): void {
    // make throttle function
    this.handleFilterChangeDebounced = _.debounce(this.handleFilterChangeDebounced, 500);

    const escalatorVersions = this.props.pdApi.EscalatorVersions;
    if ( window.location.href.includes("bindings") && (!escalatorVersions || _.isEmpty(escalatorVersions)) ) {
      // Handle the case where escalatorVersions is falsy or empty
      this.props.pdApiActions.fetchEscalatorVersions("Escalator Versions");
    }
    if (this.props.pdApi.escalatorParameters.length === 0) {
          this.props.pdApiActions.fetchEscalatorParameters();
    }
  }

  private handleFilterChangeDebounced = (changedFilters: Filter[]) => {
    this.props.setColumnFilters(this.props.subMenuRoute, changedFilters);
  };

  render(): JSX.Element {
    const { columns, mainState, isEditActive, rows, isLoadingEscalatorVersions } = this.props;
    const { editSize, pageSize, isShortenTextEnabled } = mainState;

    const selectedColumns: State.Column[] = columns["Escalator Versions"];

    return (
      <div className="table-container">
        <div className="flex-1">
          <div className="flex-1">
            <Table
              rows={rows}
              columns={selectedColumns}
              isHidingTextActive={isShortenTextEnabled}
              handleRowSelection={this.props.editActions.select}
              isRowSelected={this.isSelected}
              pageSize={pageSize}
              handleFilterChange={this.handleFilterChangeDebounced}
              loading={isLoadingEscalatorVersions}
              loadingText={"Fetching escalator versions..."}
            />
          </div>
          {isEditActive && (
            <Dimmer active={true} page={true}>
              <div className="edit-view" style={{ flex: editSize , width : editSize == 0.3 ? "500px" : "1000px" }}>
              <EditKCEVersionCommon toggleModal={this.props.toggleModal} target="Escalator" />
              </div>
            </Dimmer>
          )}
        </div>
      </div>
    );
  }

  private isSelected = (escalatorVersion: Api.EscalatorVersion): boolean => {
    const { editedObjectId } = this.props;
    if (editedObjectId && escalatorVersion.id === editedObjectId) {
      return true;
    } else {
      return false;
    }
  };
}

const mapStateToProps = (state: State.Root) => ({
  columns: state.columns,
  pdApi: state.pdApi,
  mainState: state.main,
  isLoadingEscalatorVersions: state.loadingStatus.isLoadingEscalatorVersions,
});

const mapDispatchToProps = (dispatch: Dispatch<EditActions>) => ({
  editActions: bindActionCreators({ ...editActions }, dispatch),
  pdApiActions: bindActionCreators({ ...pdApiActions }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(EscalatorVersions);
